"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    props: ["prefix"],
    methods: {
        parseValue: function parseValue() {
            this.value = this.value || (!this.$root.$data.affaireId ? [null] : "[]");
            try {
                return JSON.parse(this.value);
            } catch (e) {
                return this.value;
            }
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Workflow/Mixins/SourceControlIteration.ts
// module id = 132
// module chunks = 0